import { connect } from 'react-redux'

import WaitingScreen from './component'

const mapStateToProps = (state, props) => {
    return {
        waitingScreen: state.waitingScreen,
        dialogsOpen: state.dialogs.dialogsOpen
    }
}

const mapDispatchToProps = () => ({})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WaitingScreen)